import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';

export default function Navbar() {
  return (
    <div className='mainNav'>
      <div>
        <BrowserRouter>
          <nav className='navbar navbar-expand-lg bg-body-tertiary'>
            <div className='container-fluid'>
              <div className='collapse navbar-collapse justify-content-end' id='navbarNav'>
                <ul className='navbar-nav ml-auto'>
                  <li className='nav-item pe-4' style={{color:'white'}}>
                    <Link className='nav-link  fs-5' aria-current='page' to='#Home'>
                      Home
                    </Link>
                  </li>
                  <li className='nav-item pe-4'>
                    <Link className='nav-link fs-5' to='#About'>
                      About
                    </Link>
                  </li>
                  <li className='nav-item pe-4'>
                    <Link className='nav-link fs-5' to='#Education'>
                      Qualification
                    </Link>
                  </li>
                  <li className='nav-item pe-4'>
                    <Link className='nav-link fs-5' to='#Project'>
                      Project
                    </Link>
                  </li>
                  <li className='nav-item pe-4'>
                    <Link className='nav-link fs-5' to='#Skills'>
                      Skills
                    </Link>
                  </li>
                  <li className='nav-item pe-4'>
                    <Link className='nav-link fs-5' to='#Contact'>
                      Contact
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </BrowserRouter>
      </div>
    </div>
  );
}
